<template>
  <Disclosure as="nav" class="bg-pdsPrimaryColor shadow">
    <div class="mx-auto px-4">
      <div class="flex h-16 justify-between">
        <div class="flex">
          <div class="flex shrink-0 items-center space-x-2">
            <router-link to="/">
              <img class="h-8 w-auto" alt="Mediq TEFA" src="@/static/img/mediq_logo.svg" />
            </router-link>
            <span class="text-white">Voorschrijfportaal</span>
          </div>
        </div>
      </div>
    </div>
  </Disclosure>
</template>

<script setup>
import { Disclosure } from '@headlessui/vue';
</script>
